export enum DupDialogTypeEnum {
    Dispense,
    RegularAmendment,
    SplitNdcsAmendment
}